import { Card, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import { vitrinsCardsConfig } from 'widgets/VitrinsCards/config/constants';

import styles from './VitrinsCards.module.scss';

export const VitrinsCards = () => {
  const isMobile = useIsMobile();

  return (
    <Space
      size={isMobile ? 12 : 24}
      direction={isMobile ? 'vertical' : 'horizontal'}
      className={cn({ 'h-pl-16 h-pr-16': isMobile })}
    >
      {vitrinsCardsConfig.map((card) => (
        <Card
          className={cn({ [styles.borderRadius]: !isMobile })}
          key={card.id}
          color="blue"
          size={16}
          style={{
            width: isMobile ? '100%' : '297px',
            padding: isMobile ? '12px 16px 12px 16px' : '16px 24px 24px 24px',
          }}
        >
          <Space
            size={12}
            direction={isMobile ? 'horizontal' : 'vertical'}
            align={isMobile ? 'center' : 'start'}
          >
            <img
              style={{ flex: 'none', maxWidth: '100%' }}
              src={card.img as string}
              width={isMobile ? 52 : 80}
              height={isMobile ? 52 : 80}
              alt="feature card"
            />
            {card.title}
          </Space>
        </Card>
      ))}
    </Space>
  );
};
